define('modules/lp_integration/models/integration_zapier',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");
  module.exports = Backbone.Model.extend({
    defaults: {
      active: false,
      user_name: "",
      api_key: ""
    },
    i18n: {
      subjectError: $.i18n.t("integration.emailSubjectError"),
      recipientsError: $.i18n.t("integration.emailRecipientsError")
    },
    urlRoot: function(){
      return [config.apiHost, "pages", this.pageId, "integration"].join("/");
    },
    initialize: function(attrs,options){
      this.pageId = options.pageId;
    },
    toJSON: function(){
      return _.omit(module.exports.__super__.toJSON.apply(this), "id");
    }
  });
});

